import React, { useState } from "react"
import { Grid, Popover, Typography } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import ReviewMetadata from "./ReviewMetadata"
import useStyles from "./styles"

const ReviewDetails = ({ selectedReview }) => {
	const [t] = useTranslation("global")
	const classes = useStyles()
	const [reviewDetailsEl, setReviewDetails] = useState(null)

	const reviewDetailsOpen = Boolean(reviewDetailsEl)
	const reviewDetailsId = reviewDetailsOpen ? "simple-popover" : undefined

	return (
		<>
			{!_.isEmpty(selectedReview) ? (
				<Grid container className={classes.reviewSection}>
					<Typography className={classes.reviewName}>{selectedReview?.name}</Typography>
					<Typography
						className={classes.reviewDetails}
						aria-describedby={reviewDetailsId}
						style={{ textDecoration: reviewDetailsOpen ? "underline" : "none" }}
						onClick={(e) => setReviewDetails(e.currentTarget)}
					>
						{t("review.details")}
					</Typography>
				</Grid>
			) : (
				<></>
			)}
			<Popover
				id={reviewDetailsId}
				open={reviewDetailsOpen}
				anchorEl={reviewDetailsEl}
				onClose={() => setReviewDetails(null)}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
			>
				<ReviewMetadata selectedReview={selectedReview} />
			</Popover>
		</>
	)
}

export default ReviewDetails
